import useSWR from 'swr';
import { MerchantDetail } from '../../../interfaces/merchants';
import securedAxios from '../../../utils/secured-axios';
import { buildApiV2Url } from 'src/utils/request-url';

export const useMerchantDetail = (merchantPublicId: string) => {
  const swrKey = ['merchants', merchantPublicId];
  const fetcher = async () => {
    const { data } = await securedAxios.get<MerchantDetail>(
      buildApiV2Url(`/merchants/${merchantPublicId}`),
    );

    return data;
  };

  const { data, error, isValidating } = useSWR(swrKey, fetcher);

  return { data, error, isValidating };
};
